import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHospitalBuildingComponent } from "./med-icon-hospital-building.component";

@NgModule({
  declarations: [
    MedIconHospitalBuildingComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHospitalBuildingComponent,
  ],
})
export class MedIconHospitalBuildingModule { }
